import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './who-styles.css'
import {  ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';


function WhoWeAreBelieve() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
        <Container disableGutters className={"whoBelieveStyle"} maxWidth={false} component="section">
            <Container disableGutters className={"whoBelieveInner"} maxWidth={false} component="section">
                <Grid className={globalClasses.containerVertPadding} container>
                    <Grid className={globalClasses.containerSmall} container >
                    <Grid item xs={12}>
                        <Typography  variant="subtitle1">What We Believe</Typography>
                    </Grid>
                    <Grid item xs={12} md={5}  >
                        <Typography  variant="h2">Technology done well, does good.</Typography>
                        <Typography  variant="body1">Our mission is to help you implement innovative technology that improves the lives of the people who end up using it. </Typography>
                    </Grid>
                    <Grid item xs={false} md={1}  />
                    <Grid item xs={12} md={5}  >
                        <Typography className={globalClasses.bold} variant="body1" >We use data driven decision making and user-centered principals to design and develop high quality software. We use an iterative product-mindset that delivers continual improvement by focusing on collaboration, quality and value.  </Typography>
                    </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    </ThemeProvider>
  );
};

export default WhoWeAreBelieve;